import {
  DEMO_OPEN_AI_FAILURE,
  DEMO_OPEN_AI_REQUEST,
  DEMO_OPEN_AI_SUCCESS,
} from "../types/openAI/demo";

const initialState = { data: null, error: null, loading: false };

const fetchDemoOpenAiReducer = (state = initialState, action) => {
  switch (action.type) {
    case DEMO_OPEN_AI_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DEMO_OPEN_AI_SUCCESS:
      return {
        loading: false,
        data: action.data?.data,
        error: "",
      };
    case DEMO_OPEN_AI_FAILURE:
      return {
        loading: false,
        data: [],
        error: action.data,
      };
    default:
      return state;
  }
};

export default fetchDemoOpenAiReducer;
